{
  "企业注册邀请码": "Enterprise registration invitation codes",
  "邀请码": "Invitation code",
  "生成邀请码": "Generate invitation code",
  "邀请码已生成": "Invitation code generated",
  "邀请码、生成者、使用账号或企业": "Code, creator, account or enterprise",
  "生成者": "Created by",
  "生成时间": "Created at",
  "生成": "Generate",
  "可使用": "Available",
  "已使用": "Used",
  "已过期": "Expired",
  "使用账号": "Used by account",
  "注册企业": "Registered enterprise",
  "使用时间": "Used at",
  "长期有效": "No expiry",
  "留空则长期有效": "Leave empty for no expiry",
  "每个邀请码仅可注册一家企业。": "Each code can register one enterprise.",
  "停用此邀请码？": "Disable this invitation code?",
  "停用后无法用于注册。": "This code will no longer work for registration.",
  "邀请码已停用": "Invitation code disabled",
  "批量生成邀请码": "Generate invitation codes",
  "生成数量": "Quantity",
  "请输入 1–100 的整数": "Enter an integer from 1 to 100",
  "已生成 {{count}} 个邀请码": "Generated {{count}} invitation codes",
  "已生成的邀请码": "Generated invitation codes",
  "复制全部": "Copy all",
  "姓名或账号": "Name or account"
}
